import { createTheme } from '@material-ui/core/styles';

const theme = createTheme({
  direction: 'rtl',
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      light: '#757ce8',
      main: '#FF7500',
      dark: '#e86d02',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff7961',
      main: '#f44336',
      dark: '#ba000d',
      contrastText: '#000',
    },
  },
});

export default theme;
